import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Routes from './routes/routes'
import 'react-toastify/dist/ReactToastify.css'
import { ReduxProvider } from './lib/providers/redux-provider'
//import { PushNotificationPrompt } from './components/push/push-notification-prompt'
//import { SplashScreen } from './components/splash/splash-screen'
import './toastify-custom.css'
import { installToastConsoleMirror } from './lib/toast-console-mirror'
import EnvironmentBanner from './components/environment-banner'
import StepUpModal from './components/step-up-modal'
import AppUpdateBanner from './components/app-update-banner'
import SystemAnnouncementModal from './components/system-announcements/system-announcement-modal'
import { installChunkReload } from './lib/app-version/chunk-reload'

// Todo toast também vai para o console: ele some antes de dar tempo de ler, e a
// mensagem de erro do backend é o que mais falta depois. Ver o arquivo.
installToastConsoleMirror()

// Depois de um deploy, os pedaços do build anterior somem do servidor: quem
// está com a aba aberta e clica no menu recebe tela branca. Ver o arquivo.
installChunkReload()

function App() {
    return (
        <ReduxProvider>
            {/* Fora do Router: a tarja não depende de rota — inclusive o login
                precisa dela, que é onde o operador escolhe a aba errada. */}
            <EnvironmentBanner />
            <BrowserRouter>
                {/*
                 <SplashScreen />
                */}
                <Routes />
                {/* Montado uma vez: o interceptor HTTP o aciona quando o
                    backend pede a senha para uma ação de dinheiro. */}
                <StepUpModal />
                {/* Dentro do Router: a tarja não navega, mas o recarregamento
                    automático só faz sentido com a aplicação de pé. */}
                <AppUpdateBanner />
                {/* Avisos do painel MASTER. Busca na subida: quem estava offline
                    na publicação recebe ao entrar, e não só quem tinha a tela
                    aberta na hora. */}
                <SystemAnnouncementModal />
                <ToastContainer position="top-center" />
            </BrowserRouter>
        </ReduxProvider>
    )
}

export default App
